<footer class="footer hide-on-med-and-down">
  <!-- <p>© {{ currentYear }} GAMELEARN</p> -->
</footer>
